<script lang="ts">
  import {coinUtil} from '@/helper/coin';
  import {currency$, currentCurrencyOptions$} from './streams';
  import SelectSearch from '../SelectSearch.svelte';

  function handleCurrencyChange(e) {
    const {value = ''} = e.detail || {};
    currency$.next(value);
  }
</script>

<style>
  .token-balance {
    margin-left: auto;
  }
</style>

<span class="token-wrap">
  <SelectSearch options={$currentCurrencyOptions$} value={$currency$} on:change={handleCurrencyChange}>
    <div slot="displayItem" class="df aic">
      {#if $currency$}
        <img width="28px" height="28px" src={coinUtil.getUrl($currency$)} alt="Coin" />
        <span class="ml8 f16 T1 b">{$currency$}</span>
      {/if}
    </div>

    <div slot="item" let:option class=" df aic">
      <img width="28px" height="28px" src={coinUtil.getUrl(option.value)} alt="Coin" />
      <span class="ml8 f14 T1">{option.text}</span>
      <div class="token-balance f16 T1 fw2">{option.isCurrentChain && option.showBalance ? option.balance || '0' : '--'}</div>
    </div>
  </SelectSearch>
</span>
